import React from 'react';
import Header from "../header/Header";
import './Pages.css';
import Footer from "../footer/Footer";

const RareDiseases = () => {
    return (<div className="page-wrapper">
        <Header/>
        <div className="rare-diseases">
            <p>Πάνω από 6.000 διαφορετικές Σπάνιες Παθήσεις έχουν καταγραφεί έως σήμερα, ενώ, κάθε εβδομάδα,
                ταυτοποιούνται δέκα νέες σε όλο τον κόσμο.</p>
            <p>Πότε, όμως, μία Πάθηση ονομάζεται Σπάνια;</p>
            <p>Στην Ευρώπη, μία ασθένεια χαρακτηρίζεται σπάνια όταν εμφανίζεται σε λιγότερο από 1 στους 2.000 ανθρώπους,
                αν και οι περισσότερες από αυτές είναι τόσο σπάνιες, που μπορεί να προσβάλλουν μόλις 1, ή και λιγότερα,
                στα 100.000 άτομα.</p>
            <p>Ειδικότερα, πρόκειται για πολύπλοκες, χρόνιες και εκφυλιστικές νόσους, οι οποίες επηρεάζουν σημαντικά την
                ποιότητα ζωής των ασθενών και των οικογενειών τους. Ωστόσο, κάποιες από αυτές, εάν διαγνωστούν εγκαίρως
                και τύχουν της κατάλληλης θεραπευτικής αντιμετώπισης, επιτρέπουν στον ασθενή να έχει μία σχετικά
                φυσιολογική ζωή.</p>
            <p>Σήμερα, οι Σπάνιες Παθήσεις προσβάλλουν το 3,5% με 5,9% του παγκόσμιου πληθυσμού σε κάποια στιγμή της
                ζωής του, δηλαδή περίπου 300 εκατ. άνθρωποι παγκοσμίως ζουν με ένα Σπάνιο Νόσημα.</p>
            <p>Στην Ελλάδα, εκτιμάται πως, αυτήν τη στιγμή, νοσούν περίπου 350.000 με 600.000 συνάνθρωποί μας, και πάνω
                από 30 εκατ. άνθρωποι στην Ευρώπη.</p>
            <p>Το 50% των Σπάνιων Ασθενειών προσβάλλει παιδιά, με το 30% των παιδιών αυτών να πεθαίνει μέχρι την ηλικία
                των 5 ετών, ενώ υπολογίζεται πως σχεδόν το 50% των Σπάνιων Ασθενών είναι αδιάγνωστοι, ή παραμένουν για
                χρόνια με λανθασμένες διαγνώσεις, βιώνοντας μία μακροχρόνια «Διαγνωστική Οδύσσεια».</p>
            <p>Οι Σπάνιες Ασθένειες όχι μόνο οδηγούν σε υψηλή θνησιμότητα, αυξημένη νοσηρότητα και χαμηλή ποιότητα ζωής
                για τον ασθενή, αλλά και σε αυξημένη ψυχολογική, οικονομική και κοινωνική επιβάρυνση, τόσο για τον ίδιο,
                όσο και για την οικογένειά του. Γι’ αυτό και η ολιστική αντιμετώπισή τους, η οποία θα διασφαλίζει την
                πρόληψη και έγκαιρη διάγνωσή τους, την ισότιμη πρόσβαση των ασθενών στη φροντίδα και στις θεραπείες, την
                ενίσχυση της Έρευνας, καθώς και την προώθηση της ενημέρωσης και της ευαισθητοποίησης του κοινού γύρω από
                αυτές κρίνεται άκρως αναγκαία και επιτακτική.</p>
            <div className="images">
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <img src="/images/rare_disease/1b.jpg" alt="Image 1"/>
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <img src="/images/rare_disease/2b.jpg" alt="Image 2"/>
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <img src="/images/rare_disease/3c.jpg" alt="Image 3"/>
            </div>
        </div>
        <Footer/>
    </div>);
};

export default RareDiseases;